<template>
  <div class="body mobile">
    <!-- Header -->
    <section class="header notice">
      <div class="flexH width">
        <a class="icon iconButton third" @click.prevent="$router.push('/service')">
          <font-awesome-icon
            icon="fa-solid fa-chevron-left"
            size="lg"
          ></font-awesome-icon>
        </a>
      </div>
      <span class="fL nowrap font-bold font-white">志工平台</span>
      <div class="flexH width right"></div>
    </section>

    <!-- Main -->
    <section class="main notice pb">
      <div class="volunteer-banner">
        <div class="flexV center my-4 mx-auto">
          <div class="volunteer-banner-badge fL mb-2">本年度志工服務累積時數</div>
          <div class="fXXL text-c01 mb-1">{{ yearServiceTime.hours }}小時{{ yearServiceTime.minutes }}分鐘</div>
          <div v-if="yearServiceDate.start != ''" class="fS">統計日期：{{ yearServiceDate.start }} ~</div>
          <div v-else class="fS">統計日期：本年度尚未有服務紀錄</div>
        </div>
      </div>

      <div class="volunteer-count-hours mx-2 my-4 border-c1 fS text-c01">
        <div class="flexH">
          <img src="@/assets/icon/clock.svg" width="18" alt="總時數" class="me-1" />
          志工服務累積總時數
        </div>
        <div class="ms-auto">
          {{ serviceTime.hours }}小時{{ serviceTime.minutes }}分鐘
        </div>
      </div>

      <div class="volunteer-record-table">
        <table>
          <thead>
            <tr>
              <th class="text-left p-3 py-2 pe-0">
                <div class="fXL">志工獎勵紀錄</div>
              </th>
              <th class="p-3 py-2">
                <a @click.prevent="openRewardTermsModal" href="#" class="fS text-c01 font-normal flexH ms-auto">
                  <img src="@/assets/icon/info.svg" alt="獎勵資訊" class="me-1" />獎勵規則
                </a>
              </th>
            </tr>
          </thead>
          <tbody v-if="records.length > 0" class="cNeutral900">
            <tr v-for="(item, i) in records" :key="i">
              <td class="p-3 py-3 pe-0">
                <div class="fL mb-1">{{ item.title }}</div>
                <div class="fS text-gray-500">獲得時間 : {{ item.time }}</div>
              </td>
              <td class="p-3 py-3">
                <div class="fL flexH ms-auto nowrap">
                  <img src="@/assets/icon/coin.svg" alt="雲林幣" class="me-2" />{{ item.point }} 枚
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="2">
                <div class="m-3 p-3 fM text-center">目前無紀錄</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="volunteer-btn">
        <button @click="openThirdPartyUrl" type="button" class="fL">前往志工服務專區</button>
      </div>
    </section>

    <section v-if="rewardTermsShow" class="popup show">
      <div class="popBody">
        <a class="close" @click.prevent="closeRewardTermsModal">
          <font-awesome-icon icon="fas fa-times"></font-awesome-icon>
        </a>
        <section class="popHeader px-2">
          <b class="fL text-c01">獎勵規則</b>
        </section>
        <section class="popMain">
          <div class="fM" v-html="$t('volunteer-reward-rules')"></div>
        </section>
        <section class="popFooter flex">
          <a @click.prevent="closeRewardTermsModal" class="button flex-1 submit rounded"><span class="fM">確認</span></a>
        </section>
      </div>
    </section>

    <AlertDialog
      v-if="showAlert"
      :title="alert.title"
      :content="alert.message"
      @close="onCloseAlertDialog"
    />
  </div>
</template>

<script>
  import { convertTimestamp, formatDate } from "@/utils/date.js";
  import { volunteerApi } from "@/services/volunteer.js";
  import { ssourlApi } from "@/services/ssourl.js";
  import AlertDialog from '@/components/Dialog/AlertDialog.vue';

  export default {
    name: 'Volunteer',
    components: {
      AlertDialog
    },
    data() {
      return {
        yearServiceDate: {
          start: '',
          end: ''
        },
        yearServiceTime: {
          hours: 0,
          minutes: 0
        },
        serviceTime: {
          hours: 0,
          minutes: 0
        },
        records: [],
        rewardTermsShow: false,
        showAlert: false,
        alert: {
          title: '',
          message: ''
        },
        rewardCampaignId: process.env.VUE_APP_VOLUNTEER_CAMPAIGN_ID,
        welfareProxyUrl: process.env.VUE_APP_VOLUNTEER_WELFARE_PROXY_URL,
        welfareProxySsoAppName: process.env.VUE_APP_VOLUNTEER_WELFARE_PROXY_SSO_APP_NAME
      }
    },
    computed: {
      user() {
        return this.$store.state.user;
      }
    },
    watch: {
      user(value) {
        if (value) {
          this.initializeData();
        }
      }
    },
    mounted() {
      if (this.user)
      {
        this.initializeData();
      }
    },
    methods: {
      initializeData() {
        this.fetchRewards();
        this.fetchServiceTime();
      },

      closeRewardTermsModal() {
        this.rewardTermsShow = false;
      },

      openRewardTermsModal() {
        this.rewardTermsShow = true;
      },

      async fetchServiceTime() {
        try {
          const startDate = '2026-01-01';
          const endDate = '2126-01-01';
          const res = volunteerApi.useData(await volunteerApi.serviceTime(this.user.userId, startDate, endDate));

          if (res.code == 'SUCCESS')
          {
            this.yearServiceTime = {
              hours: res.data.filteredHours,
              minutes: res.data.filteredMinutes
            };

            this.yearServiceDate = {
              start: formatDate(startDate),
              end: formatDate(endDate)
            };

            this.serviceTime = {
              hours: res.data.totalHours,
              minutes: res.data.totalMinutes
            };
          }
          else
          {
            this.alert = {
              title: '錯誤',
              message: '查無資料'
            };

            this.showAlert = true;
          }
        } catch (err) {
          console.error(err);

          this.alert = {
            title: '錯誤',
            message: '無法取得志工服務時間資料，請稍後再試。'
          };

          this.showAlert = true;
        }
      },

      async fetchRewards() {
        try {
          const res = volunteerApi.useData(await volunteerApi.rewards(this.rewardCampaignId, this.user.userId));

          if (res.code == 'SUCCESS')
          {
            const result = [];

            res.data.forEach((v) => {
              result.push({
                title: v.reward.description,
                time: convertTimestamp(v.createdAt),
                point: v.reward.amount
              });
            });

            this.records = result;
          }
        } catch (err) {
          console.error(err);

          this.alert = {
            title: '錯誤',
            message: '無法取得志工獎勵紀錄資料，請稍後再試。'
          };

          this.showAlert = true;
        }
      },

      async openThirdPartyUrl() {
        try {
          const res = ssourlApi.useData(await ssourlApi.genurl(this.user.userId, this.welfareProxySsoAppName, this.welfareProxyUrl));

          if (res.code == 'SUCCESS') {
            window.open(res.data.ssoUrl, '_self');
          }
        } catch (err) {
          console.error(err);

          this.alert = {
            title: '錯誤',
            message: '無法取得志工服務專區SSO網址，請稍後再試。'
          };

          this.showAlert = true;
        }
      },

      onCloseAlertDialog() {
        this.showAlert = false;
        this.alert = {};
      }
    }
  };
</script>

<style lang="scss">
  .volunteer-banner {
    background: url("~@/assets/img/volunteer-banner-bg.png") no-repeat left top #FAF9FF;
    background-size: cover;
    margin: 0 -10px;
    border-radius: 0 0 1.3rem 1.3rem;
    overflow: hidden;
    box-shadow: 0px 0px 8px 4px rgba(0, 0, 0, 0.16);
    min-height: 185px !important;
  }

  .volunteer-banner-badge {
    background-color: #804EEE;
    border-radius: 30px;
    text-align: center;
    color: #fff;
    font-size: .9rem;
    padding: .3rem 1rem;
  }

  .volunteer-count-hours {
    display: flex;
    background-color: #F5F2FD;
    border-radius: 0.9rem;
    padding: 0.4rem 0.6rem;
  }

  .volunteer-record-table {
    margin: 0 -10px;

    table {
      width: 100%;
      margin: 0 !important;
      border-collapse: collapse !important;
    }

    td {
      background-color: #fff;
      border-bottom: 1px solid #e5e5e5;
      border-radius: 0 !important;
    }
  }

  .volunteer-btn {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 0;
    display: flex;
    justify-content: center;

    button {
      background-color: var(--c01);
      border-radius: 1rem;
      border: 0;
      text-align: center;
      color: var(--cWhite);
      padding: 0.7rem 0.9rem;
      margin: 0.9rem;
      flex-grow: 1;
      cursor: pointer;

      &:hover {
        background-color: #804EEE;
      }
    }
  }
</style>